import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import l200 from "./../../../../assets/info/l200-hero.jpg";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import { popularVehicle } from "../../../../vars/popularVehicles";

const MitsubishiL200 = () => {
  useSmallNav("Mitsubishi L200");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"MITSUBISHI L200 LIFT KIT"} bolder />
        <InfoHero image={l200} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Czy jesteś posiadaczem Mitsubishi L200? Szukasz części zawieszenia lub ulepszeń zawieszenia?"
              }
            />
            <InfoHeader
              size="smaller"
              text={"Jeśli tak, to trafiłeś we właściwe miejsce."}
            />
            <p>
              W firmie Pedders Suspension oferujemy szeroką gamę części
              zawieszenia, w tym liczne części wzmocnione, odpowiednie do
              wszelkich zastosowań.
            </p>
            <p>
              Dla osób przewożących ciężkie ładunki lub regularnie holujących
              jesteśmy w stanie zaoferować ulepszone tylne sprężyny i
              amortyzatory, aby lepiej sprostać wymaganiom takiego użytkowania.
            </p>
            <p>
              Dla osób poruszających się na granicy możliwości pojazdu, można je
              uzupełnić o system poduszek powietrznych. Niezależnie od
              zastosowania, będziemy mieli kombinację części do wykonania tego
              zadania.
            </p>
            <p>
              Popularne wśród naszych ulepszeń są zestawy podnoszące l200, czy
              to do poważnej jazdy w terenie, czy po prostu do bardziej
              agresywnego wyglądu. Ponownie mamy części, których potrzebujesz. W
              przypadku wielu zastosowań oferujemy wiele opcji amortyzatorów
              oraz sprężyn, dzięki czemu pojazd można dostosować do własnych
              potrzeb.
            </p>
            <p>
              Nowością w naszej ofercie L200, są w pełni zmontowane przednie
              kolumny Ezifit do niektórych zastosowań w późniejszych wersjach
              opartych na sprężynach śrubowych. Chociaż możemy dostarczyć
              amortyzatory i sprężyny osobno, tak dla wielu w pełni zmontowany
              amortyzator ma dużo zalet. Obejmują one brak wymogu stosowania
              ściągacza do sprężyn, posiadają WSZYSTKIE nowe komponenty, więc
              brak ponownego użycia starych i zużytych górnych mocowań itp., a
              także oczywiście szybkość montażu. Wystarczy odkręcić górne i
              dolne mocowania, usunąć stare i zamontować nowe. Zrobione!
            </p>
            <p>
              Jeśli sprawdziłeś naszą listę zestawów podnośników i części do
              Mitsubishi L200, ale nadal nie jesteś pewien czego potrzebujesz?
              Skontaktuj się z nami, a ktoś z naszego zespołu będzie mógł Ci
              pomóc.
            </p>
            <iframe
              title={"Mitsubishi L200 Video 1"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/rVNE11X5alo"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Mitsubishi L200 Video 2"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Mitsubishi L200 Video 3"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Mitsubishi")
              .models.find((e) => e.display === "L200")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Mitsubishi" model="L200" /> */}
      </Container>
    </section>
  );
};

export default MitsubishiL200;
